<template>
	<div>
		<h3>Activities</h3>
		<small>Testing activities new with better performances and filters!</small>
		<div class="filters row">
			<div class="col-md-2">
				<select class="form-select form-select-sm" name="" id="">
					<option value="">All</option>
					<option value="CREATED">CREATED</option>
					<option value="UPDATED">UPDATED</option>
					<option value="DELETED">DELETED</option>
				</select>
			</div>
			<div class="col-md-2">
				<select class="form-select form-select-sm" name="" id="">
					<option value="">All</option>
					<option value="CREATED">CREATED</option>
					<option value="UPDATED">UPDATED</option>
					<option value="DELETED">DELETED</option>
				</select>
			</div>
		</div>
		<div class="items-list mt-2">
			<div class="row item" v-for="item in items" :key="item.id">
				<div class="col-md-2">
					<small v-if="item.action === 'UPDATED'" class="text-primary fw-bold">{{ item.action }}</small>
					<small v-if="item.action === 'CREATED'" class="text-success fw-bold">{{ item.action }}</small>
					<small v-if="item.action === 'DELETED'" class="text-danger fw-bold">{{ item.action }}</small>
				</div>
				<div class="col-md-3">
					<code>{{ item.subject_type }}</code>
				</div>
				<div class="col-md-2">
					{{ item.subject_id }}
				</div>
				<div class="col-md-2">
					{{ item.user.name }}
				</div>
				<div class="col-md-3 text-end">
					{{ item.datetime }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
export default {
	name: 'ActivitiesNew',
	data() {
		return {
			model: 'Activity',
			route: 'activities',
			items: [],
			params: {
				page: 1,
				orderBy: 'id',
				direction: 'desc',
				perPage: 20,
			},
			pagination: {},
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	created() {
		this.getActivities()
	},
	methods: {
		// Get all items
		getActivities() {
			restApi
				.get(`/${this.route}`, { params: this.params })
				.then(({ data }) => {
					this.items = data.data
					// Store pagination and remove data from that object
					this.pagination = data
					delete this.pagination.data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: error,
						timer: 4000,
					})
				})
		},
	},
}
</script>

<style lang="scss">
.items-list {
	.item {
		border-bottom: 1px solid #fefefe;
		border-radius: 5px;
	}
	:hover {
		background-color: #cdcdcd;
		cursor: pointer;
	}
}
</style>
